import React from 'react';
import { motion } from 'framer-motion';
import { FaPrayingHands, FaCalendarAlt, FaVideo, FaBible } from 'react-icons/fa';

// import './HomePage.css'; // Optional: for custom styling

const Hero = () => {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 2 }}
          // style={{
          //   textAlign: 'center',
          //   color: '#ffffffff',
          //   fontSize: '2.5rem',
          //   fontFamily: 'Georgia, serif',
          //   textShadow: '0 0 15px rgba(255,255,255,0.6)'
          // }}
        >
          Welcome to RCCG David's Court 
        </motion.h1>
        {/* <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          “For where two or three gather in my name, there am I with them.” — Matthew 18:20
        </motion.p> */}
      </section>

      {/* Quick Links */}
      <section className="quick-links">
        <motion.div className="link-card" whileHover={{ scale: 1.05 }}>
          <FaCalendarAlt size={40} />
          <h3>Service Times</h3>
          <p>Sundays 10AM</p>
        </motion.div>

        {/* <motion.div className="link-card" whileHover={{ scale: 1.05 }}>
          <FaBible size={40} />
          <h3>Bible Studies</h3>
          <p>Sundays 9AM</p>
        </motion.div> */}

        <motion.div className="link-card" whileHover={{ scale: 1.05 }}>
         <a href="https://www.youtube.com/@davidscourt3995/streams"
              target="_blank" rel="noopener noreferrer"><FaVideo size={40} />
          <h3>Livestream</h3>
          <p>Join us live every Sunday</p></a>
        </motion.div>

        <motion.div className="link-card" whileHover={{ scale: 1.05 }}>
          <FaPrayingHands size={40} />
          <h3>Prayer Requests</h3>
          <p>We are here to pray with you</p>
        </motion.div>
      </section>

      {/* Call to Action */}
      <section className="cta">
        <motion.button
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2.5, duration: 1 }}
        style={{ marginTop: '2rem', textAlign: 'center', pointerEvents: 'auto' }}
          whileHover={{ scale: 1.1 }}
          className="cta-button"
          onClick={() => window.location.href = '/visit'}
        >
          Plan Your Visit
        </motion.button>
      </section>
    </div>
  );
};

export default Hero;
